import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'setCampaignDisabledFlag'

export default ({ campaignId, disabled }) => {
  return asyncAction(
    name,
    CampaignsService.setCampaignDisabledFlag,
    { campaignId, disabled }
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/setCampaignDisabledFlag.js